import { render, staticRenderFns } from "./udate-form.vue?vue&type=template&id=3b09adf0&scoped=true"
import script from "./udate-form.vue?vue&type=script&lang=js"
export * from "./udate-form.vue?vue&type=script&lang=js"
import style0 from "./udate-form.vue?vue&type=style&index=0&id=3b09adf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b09adf0",
  null
  
)

export default component.exports